import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import pretty from '@st-operations/uikit/lib/pretty'

import UnionSvg from './union.svg'
import CalendarSvg from './calendar.svg'

import './styles.scss'

const FREQUENCY_DAILY_VALUE = 'daily'
const FREQUENCY_MONTHLY_VALUE = 'monthly'
const FREQUENCY_LIVE_VALUES = [FREQUENCY_DAILY_VALUE, FREQUENCY_MONTHLY_VALUE]

const DeliveryStatus = ({ className, data = {} }) => {
  return (
    <div className={classNames('delivery-status', className)}>
      <div className="delivery-status__row">
        <Choose>
          <When condition={data.isSample === true}>
            <UnionSvg style={{ marginRight: 10 }} />
          </When>
          <When condition={FREQUENCY_LIVE_VALUES.includes(data.frequency)}>
            <CalendarSvg style={{ marginRight: 10 }} />
          </When>
        </Choose>
        <div className="delivery-status__column">
          <div className="delivery-status__row">
            <Choose>
              <When condition={data.frequency === FREQUENCY_DAILY_VALUE}>
                <span className="delivery-status__bold">Daily</span>
              </When>
              <When condition={data.frequency === FREQUENCY_MONTHLY_VALUE}>
                <span className="delivery-status__bold">Monthly</span>
              </When>
              <Otherwise>
                <span>{"You haven't added a delivery yet"}</span>
              </Otherwise>
            </Choose>
            <span className="delivery-status__spaced"> • </span>
            <span
              className={classNames(
                'delivery-status__badge',
                `delivery-status__badge--${data.status}`
              )}
            >
              {pretty(data.status)}
            </span>
          </div>
          <If condition={data.format || data.compression}>
            <div className="delivery-status__row">
              <span className="delivery-status__uppercase">{data.format}&nbsp;</span>
              <span className="delivery-status__uppercase">{data.compression}&nbsp;</span>
              <If condition={data.s3Location}> to {data.s3Location}</If>
            </div>
          </If>
        </div>
      </div>
    </div>
  )
}

DeliveryStatus.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    isSample: PropTypes.bool,
    frequency: PropTypes.string,
    status: PropTypes.string,
    format: PropTypes.string,
    compression: PropTypes.string,
    s3Location: PropTypes.string,
  }).isRequired,
}

export default DeliveryStatus
